import { RootState } from '@reducers';

export const selectClaimEditModal = (state: RootState) => state.userDashboardRouteReducer.claimEditModal;
